import { render, staticRenderFns } from "./CreateTaskRightClickModal.vue?vue&type=template&id=4b6692dc&scoped=true&"
import script from "./CreateTaskRightClickModal.vue?vue&type=script&lang=js&"
export * from "./CreateTaskRightClickModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6692dc",
  null
  
)

export default component.exports